import {Component, computed, inject, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableModule} from 'primeng/table';
import {Button} from 'primeng/button';
import {TranslocoPipe} from '@jsverse/transloco';
import {CompanyOfficeDetailResponse} from '@frontend/shared-api';
import {CountryService} from '@frontend/shared';
import {last} from 'rxjs';
import {BackgroundCardComponent} from '../titled-background-card/background-card.component';
import {NoDataComponent} from '../no-data/no-data.component';
import {GlobalSearchComponent} from '../search/global-search/global-search.component';
import {LoadingComponent} from '../loading/loading.component';

export interface TableColumn {
  field: string;
  headerKey: string;
  testId: string;
  width?: string;
}

@Component({
  selector: 'app-office-list',
  imports: [
    CommonModule,
    TableModule,
    Button,
    TranslocoPipe,
    BackgroundCardComponent,
    NoDataComponent,
    GlobalSearchComponent,
    LoadingComponent,
  ],
  templateUrl: './office-list.component.html',
})
export class OfficeListComponent {
  readonly offices = input<CompanyOfficeDetailResponse[]>([]);
  readonly loading = input(false);
  readonly columns = input<TableColumn[]>([]);
  readonly globalFilterFields = input<string[]>([]);
  readonly headerKey = input('');
  readonly showCount = input(false);
  readonly showCreate = input(false);
  readonly showEdit = input(false);
  readonly edit = output<number>();
  readonly create = output<void>();

  protected readonly countryService = inject(CountryService);
  protected readonly last = last;

  protected readonly hasOffices = computed<boolean>(() => this.offices().length > 0);

  protected readonly showCreateAction = computed<boolean>(
    () => this.hasOffices() && this.showCreate(),
  );
}
